import { http } from '@/app/lib/http/client'

export type BannerType = 'HERO' | 'BANNER_GRID_3'

export interface StoreBannerSlide {
  id: number
  banner_id: number
  image_url: string
  call_to_action_url?: string | null
  sort_order: number
  is_active: boolean
  created_at?: string
  updated_at?: string
}

export interface StoreBanner {
  id: number
  company: string
  name: string
  type: BannerType
  is_active: boolean
  starts_at?: string | null
  ends_at?: string | null
  created_at?: string
  updated_at?: string
  slides: StoreBannerSlide[]
}

export interface Paginator<T> {
  current_page: number
  data: T[]
  from: number
  last_page: number
  per_page: number
  to: number
  total: number
}

export const bannerService = {
  async getBanners(params: { page?: number; per_page?: number; search?: string }): Promise<{ data: Paginator<StoreBanner> }> {
    const response = await http.get('/ecommerce/banners', { params })
    return response.data
  },

  async getBanner(id: number): Promise<StoreBanner> {
    const response = await http.get(`/ecommerce/banners/${id}`)
    return response.data.data
  },

  async createBanner(data: FormData): Promise<StoreBanner> {
    const response = await http.post('/ecommerce/banners', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data.data
  },

  async updateBanner(id: number, data: FormData): Promise<StoreBanner> {
    // Some frameworks require _method=PUT or PATCH when sending multipart/form-data via POST
    data.append('_method', 'PUT')
    const response = await http.post(`/ecommerce/banners/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data.data
  },

  async deleteBanner(id: number): Promise<void> {
    await http.delete(`/ecommerce/banners/${id}`)
  },

  async toggleBannerStatus(id: number): Promise<void> {
    await http.patch(`/ecommerce/banners/${id}/status`)
  },
}
